// Client Static Value
import { VERSION } from '../common/config';
export const NICE_AUTH_URL = "https://nice.checkplus.co.kr/CheckPlusSafeModel/checkplus.cb";

// export const TOSS_PAYMENTS_CLIENT_KEY = "live_ck_YZ1aOwX7K8mdxeENJgmryQxzvNPG";
export const FORNAX_VERSION = VERSION;
export const LOCALSTORAGE = {
    REMEMBER_ID: "rememberid",

    USER_ID: "userid",
    USER_ACCT: "useracct",
    USER_FIRST: "userfirst",
    GROUP_ID: "groupid",

    SELECTED_VM_ID: "selected_vm_id",
    SELECTED_SERVICE_ID: "selected_service_id",

    REMOTE_BACKUP_STORAGE_PROTOCOL: "rmt_bs_proto",
    REMOTE_BACKUP_STORAGE_IP: "rmt_bs_ip",
    REMOTE_BACKUP_STORAGE_PORT: "rmt_bs_port",
    REMOTE_BACKUP_STORAGE_ACCOUNT: "rmt_bs_accnt",
    REMOTE_BACKUP_STORAGE_PASS: "rmt_bs_pass",
    REMOTE_BACKUP_STORAGE_PATH: "rmt_bs_path"
}

export const SESSIONSTORAGE = {

    // Usage LOGIN
    USER_ID: "userId",
    USER_NAME: "userName",
    USER_EMAIL: "userEmail",
    USER_FULLNAME: "userFullname",
    API_KEY: "apiKey",
    RSH_KEY: "resKey",
    USER_ROLE: "userRole",
    PROJECT_ROLE: 'ProejctRole',
    USER_COMPANY_NAME: "userCompanyName",
    PHONE_NUMBER: 'phoneNumber',
    DEPARTMENT_NAME: 'departmentNmae',
    DEPARTMENT_RANK: 'departmentRank',
    PROJECT_NAME: 'projectName',
    FIRST_LOGIN: 'firstLogin',
    EMAIL_YN: 'emailYn',
    SMS_YN: 'smsYn',
    USER_STATUS_CODE: 'userStatusCode',
    PROJECT_ID: "userProjectId",

    // Storage
    STORAGE_POOL_DETAIL_ID: 'stooragePoolDetailId',
    BACKUPS_RESTORE_ID: 'BackupsResotreId',
    BACKUPS_IP: 'BackupIp',
    BACKUPS_PORT: 'BackupPort',
    BACKUPS_ID: 'BackupId',
    BACKUPS_PASSWORD: 'BackupPassword',
    BACKUPS_PATH: 'BackupPath',

    ACCOUNT_USER_ID: "accountUserId",

    DESHBOARD_VIEW: "dashboardView",

    TABLE_ID: "tableId",
    TABLE_PAGE_SIZE: "tablePageSize",
    TABLE_PAGE_INDEX: "tablePageIndex",
    TABLE_SEARCH: "tableSearch",
    TABLE_CATEGORY_FILTER_TYPE: "tableCategoryFilterType",
    TABLE_CATEGORY_FILTER_VALUE: "tableCategoryFilterValue",
    TABLE_SORTY_BY_TYPE: "tableSortByType",
    TABLE_SORTY_BY_DESC_YN: "tableSortByDescYn",

    HOST_CLUSTER_TARGET_ID: "hostClusterId",

    VM_TARGET_ID: "vmTargetId",
    VOLUME_TARGET_ID: "volumeTargetId",

    VM_NETWORK_TARGET_ID: "vmNetworkTargetID",

    DOMAIN_TARGET_ID: "domainId",
    PROJECT_TARGET_ID: "projectId",

    SECURITY_GROUP_TARGET_ID: "securityGroupId",
    ROUTER_TARGET_ID: "routerId",

    CONTAINER_CLUSTER_TARGET_ID: "containerClusterId",

    POD_TARGET_ID: "podId",
    POD_PROFILE_TARGET_ID: "podProfileId",
    DEPLOYMENT_TARGET_ID: "deploymentId",

    NOTICE_DETAIL_TARGET_ID: "noticeTargetId",
    FAQ_DETAIL_TARGET_ID: "faqTargetId",
    QUESTION_DETAIL_TARGET_ID: "questionTargetId",
    DOMAIN_ID: "userDomainId",


    SERVICE_PRODUCT_TARGET_ID: "svcPrdId",
    SERVICE_LICENSE_TARGET_ID: "svcLicsId",
    SERVICE_PURCHASE_TARGET_ID: "svcPchsId",

}

export const FONT = {
    REGULAR: "NotoSansKR-Regular",
    MEDIUM: "NotoSansKR-Medium",
    BOLD: "NotoSansKR-Bold",
    LIGHT: "NotoSansKR-Light",
    BLACK: "NotoSansKR-Black",
    THIN: "NotoSansKR-Thin",
}